import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import {
  primaryColor,
  borderSubtleColor,
  textMutedColor,
  textPrimaryColor,
} from 'assets/jss/material-dashboard-react';

const styles = {
  field: {
    width: '100%',
    margin: '14px 0',
    position: 'relative',
  },
  label: {
    display: 'block',
    fontFamily: 'FrutigerRegular, Tahoma, Arial, sans-serif',
    fontSize: 13,
    fontWeight: 500,
    color: textMutedColor,
    marginBottom: 8,
    textAlign: 'right',
  },
  control: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row-reverse',
    width: '100%',
    boxSizing: 'border-box',
    minHeight: 48,
    padding: '0 14px',
    border: `1px solid ${borderSubtleColor}`,
    borderRadius: 12,
    backgroundColor: '#FAFCFC',
    transition: 'border-color 0.15s ease, background-color 0.15s ease, box-shadow 0.15s ease',
    '&:hover': {
      borderColor: '#C5D0D6',
      backgroundColor: '#fff',
    },
  },
  controlFocused: {
    borderColor: primaryColor,
    backgroundColor: '#fff',
    boxShadow: '0 0 0 3px rgba(0, 168, 188, 0.12)',
  },
  input: {
    flex: 1,
    width: '100%',
    border: '0 !important',
    outline: 'none !important',
    background: 'transparent',
    boxShadow: 'none !important',
    fontFamily: 'FrutigerRegular, Tahoma, Arial, sans-serif',
    fontSize: 15,
    color: textPrimaryColor,
    padding: '12px 0',
    textAlign: 'right',
    direction: 'rtl',
    WebkitAppearance: 'none',
    MozAppearance: 'none',
    appearance: 'none',
    '&:focus, &:focus-visible, &:active': {
      border: '0 !important',
      outline: 'none !important',
      boxShadow: 'none !important',
    },
    '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
      WebkitAppearance: 'none',
      margin: 0,
    },
    '&[type=number]': {
      MozAppearance: 'textfield',
    },
    '&::placeholder': {
      color: '#B0B8BF',
      opacity: 1,
    },
    // Kill Chrome autofill yellow / extra chrome
    '&:-webkit-autofill, &:-webkit-autofill:hover, &:-webkit-autofill:focus': {
      WebkitBoxShadow: '0 0 0 1000px #FAFCFC inset !important',
      WebkitTextFillColor: textPrimaryColor,
      caretColor: textPrimaryColor,
      border: '0 !important',
      outline: 'none !important',
      transition: 'background-color 9999s ease-in-out 0s',
    },
  },
  icon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#A0AAB0',
    marginLeft: 0,
    marginRight: 10,
    flexShrink: 0,
    '& svg': {
      fontSize: 18,
    },
  },
};

class AuthField extends React.Component {
  state = { focused: false };

  handleFocus = e => {
    this.setState({ focused: true });
    if (this.props.onFocus) this.props.onFocus(e);
  };

  handleBlur = e => {
    this.setState({ focused: false });
    if (this.props.onBlur) this.props.onBlur(e);
  };

  render() {
    const {
      classes,
      label,
      id,
      type,
      value,
      onChange,
      autoFocus,
      icon,
      placeholder,
      inputProps,
    } = this.props;
    const { focused } = this.state;

    return (
      <div className={classes.field}>
        {label ? (
          <label className={classes.label} htmlFor={id}>
            {label}
          </label>
        ) : null}
        <div className={`${classes.control} ${focused ? classes.controlFocused : ''}`}>
          {icon ? <span className={classes.icon}>{icon}</span> : null}
          <input
            id={id}
            type={type}
            value={value}
            onChange={onChange}
            onFocus={this.handleFocus}
            onBlur={this.handleBlur}
            // eslint-disable-next-line jsx-a11y/no-autofocus
            autoFocus={autoFocus}
            placeholder={placeholder}
            className={classes.input}
            {...inputProps}
          />
        </div>
      </div>
    );
  }
}

AuthField.propTypes = {
  autoFocus: PropTypes.bool,
  classes: PropTypes.object.isRequired,
  icon: PropTypes.node,
  id: PropTypes.string,
  inputProps: PropTypes.object,
  label: PropTypes.node,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

AuthField.defaultProps = {
  type: 'text',
  autoFocus: false,
  value: '',
};

export default withStyles(styles)(AuthField);
